@if (isInitialized) {
  <oe-chart [title]="'GENERAL.GRID' | translate" [showPhases]="showPhases" (setShowPhases)="setShowPhases($event)"
    [period]="service.historyPeriod">
    <gridchart [isOnlyChart]="true" [showPhases]="showPhases" [showTotal]="showTotal">
    </gridchart>
  </oe-chart>
}
@if (isInitialized && isAllowed) {
  <oe-footer-subnavigation [navigationOptions]="navigationButtons" ></oe-footer-subnavigation>
}
